import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import {
  clearItineraryHistoryAlerts,
  getItineraryHistoryAlerts,
} from '../../../../../actions';
import Table from '../../../../common/Table';
import { DEFAULT_PAGE_SIZE } from '../../../../../config/constants';
import { ITINERARY_HISTORY_ALERT_COLUMNS } from '../../../../../config/columns';

const ItineraryHistoryAlerts = ({
  itineraryId,
  dispatchGetItineraryHistoryAlerts,
  dispatchClearItineraryHistoryAlerts,
  historyAlerts,
  historyAlertsLoading,
}) => {
  useEffect(() => {
    dispatchGetItineraryHistoryAlerts(itineraryId);
    return () => {
      dispatchClearItineraryHistoryAlerts();
    };
  }, []);

  return (
    <Table
      manual={false}
      data={historyAlerts}
      filterable
      loading={historyAlertsLoading}
      columns={ITINERARY_HISTORY_ALERT_COLUMNS}
      defaultPageSize={DEFAULT_PAGE_SIZE}
    />
  );
};

ItineraryHistoryAlerts.propTypes = {
  itineraryId: PropTypes.number.isRequired,
  dispatchGetItineraryHistoryAlerts: PropTypes.func.isRequired,
  dispatchClearItineraryHistoryAlerts: PropTypes.func.isRequired,
  historyAlerts: PropTypes.instanceOf(Immutable.List).isRequired,
  historyAlertsLoading: PropTypes.bool,
};

ItineraryHistoryAlerts.defaultProps = {
  historyAlertsLoading: false
}

const mapStateToProps = ({ ItineraryUnit }) => ({
  historyAlerts: ItineraryUnit.Itinerary.getIn([
    'current',
    'historyAlerts',
  ]).toJS(),
  historyAlertsLoading: ItineraryUnit.Itinerary.getIn([
    'current',
    'historyAlertsLoading',
  ]),
});

const mapDispatchToProps = {
  dispatchGetItineraryHistoryAlerts: getItineraryHistoryAlerts,
  dispatchClearItineraryHistoryAlerts: clearItineraryHistoryAlerts,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ItineraryHistoryAlerts);
